<template>
  <div class="header">
    <div class="logo-wrapper--lg">
      <img src="../imgs/icons/logo@2x.png" class="header-logo--lg" />
    </div>
    <div class="container">
      <div class="header-content">
        <img src="../imgs/icons/logo@2x.png" class="header-logo" />
        <h1 class="header-title">网安警务室</h1>
        <!-- <p class="header-desc">互联网不良信息举报中心</p> -->
      </div>
      <van-config-provider :theme-vars="themeVars">
        <van-tabs class="header-nav" v-model:active="active" :ellipsis="false">
          <van-tab title="党建园地" to="/news-category?category=党建园地"></van-tab>
          <van-tab title="预警提示" to="/news-category?category=预警提示"></van-tab>
          <van-tab title="网络宣传" to="/news-category?category=网络宣传"></van-tab>
          <van-tab title="在线服务" to="/report"></van-tab>
          <van-tab title="关注我们" to="about"></van-tab>
          <!-- <van-tab title="党建园地" to="newslist?type=5"></van-tab>
          <van-tab title="预警提示" to="newslist?type=3"></van-tab>
          <van-tab title="典型案例" to="newslist?type=1"></van-tab>
          <van-tab title="法律法规" to="newslist?type=2"></van-tab>
          <van-tab title="历史记忆" to="newslist?type=4"></van-tab>
          <van-tab title="网民举报" to="report"></van-tab>
          <van-tab title="举报进度" to="progress"></van-tab> -->
        </van-tabs>
      </van-config-provider>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab, ConfigProvider } from 'vant';
import { defineComponent, getCurrentInstance } from 'vue';
import { ref } from 'vue';
export default defineComponent({
  name: 'NetaccuseHeader',
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    'van-config-provider': ConfigProvider
  },
  setup() {
    // 处理获取路由信息，定位active
    const { proxy } = getCurrentInstance();
    const route = proxy.$route;
    // const activeArr = [5, 3, 1, 2, 4, 'report', 'progress'];
    const activeArr = ['党建园地', '预警提示', '网络宣传', 'report', 'about'];
    let name = route.name;
    // 高亮分类，当切换分类下面list时候高亮当前分类
    if (route.name === 'newsCategory' || route.name === 'newslist') {
      name = route.query.category || 'report';
    }
    const active = ref(activeArr.indexOf(name));

    // 设置tab主题
    const themeVars = {
      tabTextColor: '#fff',
      tabActiveTextColor: '#fff',
      tabDisabledTextColor: '#fff',
      // tabFontSize: '15px',
      // tabLineHeight: '28px',
      tabFontSize: '18px',
      tabLineHeight: '30px',
      tabsDefaultColor: '#fff',
      // tabsLineHeight: '28px',
      // tabsCardHeight: '28px',
      tabsLineHeight: '38px',
      tabsNavBackgroundColor: 'none',
      // tabsBottomBarWidth: '56px',
      tabsBottomBarHeight: '2px',
      tabsBottomBarColor: '#fff'
    };
    // 设置tab值
    // nextTick(() => {
    // const $tabsLine = document.getElementsByClassName('van-tabs__line')[0];
    // const $tab = document.getElementsByClassName('van-tab')[active.value];
    // $tabsLine.style.width = $tab.clientWidth + 'px';
    // });
    // const onClickTab = () => {
    // const $current = document.getElementsByClassName('van-tab--active')[0];
    // const w = $current.clientWidth;
    // if (w) {
    //   const $tabsLine = document.getElementsByClassName('van-tabs__line')[0];
    //   setTimeout(() => {
    //     $tabsLine.style.width = w + 'px';
    //   }, 0);
    // }
    // };
    return {
      themeVars,
      active
    };
  }
});
</script>
<style lang="scss">
@import '../style/config';
html {
  font-size: 188px !important;
}
.container {
  max-width: 1500px;
  margin: 0 auto;
}
.header {
  --van-tabs-bottom-bar-width: 120px;

  // min-height: 256px;
  // padding: 32px 20px 20px 40px;
  padding: 20px 0;
  margin-bottom: 40px;
  background-color: $primary;
  color: #fff;
  background-image: url('../imgs/icons/header_bg@2x.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  &-logo {
    float: left;
    width: 141px;
    height: 141px;
    margin-left: 40px;
    margin-right: 48px;
  }
  &-content {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  &-title {
    font-size: 60px;
  }
  &-desc {
    font-size: 32px;
  }
  &-nav {
    font-size: 28px;
    color: #fff;
    // .van-tab {
    //   flex: unset;
    //   padding: 0;
    //   margin-right: 32px;
    // }
  }
}
.van-container-top {
  margin-top: 60px;
}

@media screen and (max-width: 1024px) {
  .logo-wrapper--lg {
    display: none;
  }
}

@media screen and (min-width: 1024px) {
  .header {
    min-height: 270px;
  }
  .header-logo {
    display: none;
    &--lg {
      width: 257px;
      height: 248px;
      position: absolute;
      left: -220px;
      top: -9px;
    }
  }
  .header-title {
    font-size: 76px;
    margin: 30px 0 0 90px;
  }
  .logo-wrapper--lg {
    max-width: 20rem;
    margin: 0 auto;
    position: relative;
  }
}

// @media screen and (max-width: 480px) {
//   .van-tabs {
//     --van-tab-font-size: 24px;
//   }
// }
</style>
